module.exports = __webpack_public_path__ + "img/p10.5ab7cdf1.png";